import { TypeA11yTextFields } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { mapSpacer } from 'src/siteBuilder/renderer/contentful/mapSpacer'

import A11yText from './A11yText'

const ContentfulA11yText = withContentful<TypeA11yTextFields>(A11yText, { spacer: mapSpacer })
export default ContentfulA11yText
